import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import FilterIcon from "../../../../DefaultStyles/FilterIcon";
import DropDown, { OptionType } from "../../../../Filters/DropDown";

interface UserDetailPartyInfoFilterProps {
  setFilter: Dispatch<SetStateAction<{ state: string }>>;
  btnDisabled: boolean;
}

export default function UserDetailPartyInfoFilter({
  setFilter,
  btnDisabled,
}: UserDetailPartyInfoFilterProps) {
  const [partyState, setPartyState] = useState<OptionType>({
    value: "",
    label: "나의 상태 선택",
  });

  // 파티 상태 옵션
  const partyStateOption = [
    { value: "1", label: "진행중" },
    { value: "0", label: "예정" },
    { value: "2", label: "종료/탈퇴/해산 (숨기기 포함)" },
  ];

  return (
    <FilterContainer>
      <FilterIcon maxWidth={0} />

      <DropDown
        optionList={partyStateOption}
        dropdownValue={partyState}
        setDropDownValue={setPartyState}
        boxWidth={200}
        isDisabled={btnDisabled && partyState?.value === ""}
      />

      <ConfirmBtn
        btnText="적용"
        btnColor="mint"
        btnClickEvent={() => {
          setFilter({
            state: partyState?.value!,
          });
        }}
        isDisabled={partyState?.value === ""}
      />

      <LineBtn
        btnColor="mint"
        btnText="초기화"
        icon="refresh"
        btnHeight={38}
        disabled={partyState?.value === ""}
        btnClickEvent={() => {
          setFilter({
            state: "",
          });

          setPartyState({
            value: "",
            label: "파티 상태 선택",
          });
        }}
      />
    </FilterContainer>
  );
}

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 12px;
`;
